import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { PhotoInput, PhotoText, UploadPhotoWrapper } from './styled';
import Icon from '../../../../Icon';
import PhotoIcon from '../../../../../public/static/images/new_ad/icons/icon-photo.svg';

interface UploadPhotoButtonProps {
  hasImages?: boolean;
  onChange: (files: FileList | null) => void;
}

export const UploadPhotoButton: React.FC<UploadPhotoButtonProps> = ({
  hasImages = false,
  onChange
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();

  const handleAddPhoto = () => {
    fileInputRef.current?.click();
  };

  return (
    <UploadPhotoWrapper
      tabIndex={0}
      role="button"
      onClick={handleAddPhoto}
      onKeyPress={handleAddPhoto}
      hasImages={hasImages}
      data-cy="item-modal-photo-upload"
    >
      <Icon width={37} height={29} IconComponent={PhotoIcon} indent={false} />
      <PhotoText tag="body_1" data-cy="item-modal-photo-text">
        {hasImages ? t('header.new_ad') : t('new_ad.add_photo')}
      </PhotoText>
      <PhotoInput
        multiple
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={event => onChange(event.target.files)}
      />
    </UploadPhotoWrapper>
  );
};
